import { useEffect, useState } from "react";
import { Button, Paper, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import VariantDimensionModal from "../components/VariantDimensionModal";
import { deleteVariantDimension, listVariantDimensions } from "../api/variantDimensions";
import { EmptyState, PageHeader, StatusBadge } from "../components/ui";

function SupportVariantDimensions() {
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(null);

  function load() {
    listVariantDimensions().then(setList).catch((err) => {
      console.error("DIMENSION LOAD ERROR", err);
      alert("Yüklenemedi");
    });
  }

  useEffect(() => {
    load();
  }, []);

  function remove(id) {
    if (!window.confirm("Silmek istiyor musun?")) return;
    deleteVariantDimension(id).then(load);
  }

  return (
    <Stack spacing={2}>
      <PageHeader
        title="Destek Tabloları / Varyant Anahtarları"
        subtitle="Malzeme varyantlarında kullanılacak anahtarları yönetin."
        actions={
          <Button
            variant="contained"
            onClick={() => {
              setSelected(null);
              setOpen(true);
            }}
          >
            + Yeni Anahtar
          </Button>
        }
      />

      {!list.length ? (
        <EmptyState description="Henüz varyant anahtarı yok." actionLabel="+ Yeni Anahtar" onAction={() => setOpen(true)} />
      ) : (
        <Paper>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Key</TableCell>
                <TableCell>Label</TableCell>
                <TableCell>Tip</TableCell>
                <TableCell align="right">İşlemler</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {list.map((d) => (
                <TableRow key={d.id} hover>
                  <TableCell>
                    <Typography sx={{ fontWeight: 800 }}>{d.key}</Typography>
                  </TableCell>
                  <TableCell>{d.label}</TableCell>
                  <TableCell>
                    <StatusBadge value={d.value_type || "—"} />
                  </TableCell>
                  <TableCell align="right">
                    <Stack direction="row" spacing={1} justifyContent="flex-end">
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => {
                          setSelected(d);
                          setOpen(true);
                        }}
                      >
                        Düzenle
                      </Button>
                      <Button size="small" color="error" variant="outlined" onClick={() => remove(d.id)}>
                        Sil
                      </Button>
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      )}

      {open ? <VariantDimensionModal data={selected} onClose={() => setOpen(false)} onSaved={load} /> : null}
    </Stack>
  );
}

export default SupportVariantDimensions;

